import { createSlice } from "@reduxjs/toolkit";
import { userProfile } from "../services/operations/userProfile";

const initialState = {
  company: [], // Initialize as an empty array to match API response
  status: "idle", // Possible values: 'idle', 'loading', 'succeeded', 'failed'
  error: null,
};

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    setCompany: (state, action) => {
      state.company = action.payload;
    },
    resetCompany: (state) => {
      state.company = null; // Reset to null
      state.status = "idle"; // Reset status
      state.error = null; // Clear any errors
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userProfile.pending, (state) => {
        state.status = "loading";
        state.error = null; // Clear any previous errors
      })
      .addCase(userProfile.fulfilled, (state, action) => {
        const { actionType, data } = action.payload;

        switch (actionType) {
          case "list":
            state.company = data || null; // Ensure company is an array
            break;
          case "create":
          case "update":
            state.company = data; // Wrap the data in an array
            break;
          case "delete":
            state.company = null; // Reset to an empty array
            break;
          default:
            break;
        }

        state.status = "succeeded"; // Reset status after successful operation
      })
      .addCase(userProfile.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message; // Use action.error.message for error details
      });
  },
});

export const { setCompany, resetCompany } = userProfileSlice.actions;
export default userProfileSlice.reducer;